(() => {
  $('.ProductListWrapper').on('click', '.product__colors a', function (e) {
    e.preventDefault();
    let currentImage = e.currentTarget;
    if (currentImage.classList.contains('currentVariant')) {
      return;
    }

    const {
      product_id: productId,
      title,
      price,
      compareAtPrice,
      imageUrl,
      altImageUrl,
      url,
      productInfoTags,
      images,
      rolloverImageNumber,
    } = currentImage.dataset;

    let cardsProduct = $(`#productId_${productId}`);
    let productItemElement = cardsProduct[0];
    let productInfo = cardsProduct.find('.product-info-tags');
    productInfo.text(productInfoTags);

    if (
      images &&
      productItemElement?.tagName.toLowerCase() === 'product-item'
    ) {
      try {
        const imageUrls = images.split('||').filter((url) => url?.trim());

        if (productItemElement.updateImages && imageUrls.length > 0) {
          const rolloverNumber = rolloverImageNumber
            ? parseInt(rolloverImageNumber, 10)
            : null;

          productItemElement.updateImages(imageUrls, rolloverNumber);
        } else {
          handleLegacyImageUpdate(cardsProduct, {
            title,
            imageUrl,
            altImageUrl,
          });
        }
      } catch (e) {
        console.warn('Failed to update carousel images:', e);

        handleLegacyImageUpdate(cardsProduct, { title, imageUrl, altImageUrl });
      }
    } else {
      handleLegacyImageUpdate(cardsProduct, { title, imageUrl, altImageUrl });
    }

    cardsProduct.find('.currentVariant').removeClass('currentVariant');
    currentImage.classList.add('currentVariant');
    cardsProduct.find('a').attr('href', url);
    cardsProduct.find('.ProductItem__Title a').text(title);

    cardsProduct
      .find('.Price--highlight .tlab-currency-format')
      .text(formatter.format(price / 100));

    const compareAtElement = cardsProduct.find(
      '.Price--compareAt .tlab-currency-format',
    );

    compareAtElement.text(
      compareAtPrice != 0 ? formatter.format(compareAtPrice / 100) : '',
    );
  });

  const handleLegacyImageUpdate = (
    cardsProduct,
    { title, imageUrl, altImageUrl },
  ) => {
    const image = cardsProduct.find('.Image--fadeIn.lazyautosizes');
    const altImage = cardsProduct.find(
      '.ProductItem__Image--alternate.lazyautosizes',
    );

    if (altImage.length === 0 && altImageUrl) {
      insertImageAltImage(cardsProduct, { title, altImageUrl });
      image.addClass('ProductItem__Image');
    }

    if (altImage.length === 1 && !altImageUrl) {
      image.removeClass('ProductItem__Image');
      altImage.remove();
    }

    image.attr('srcset', imageUrl);
    altImage.attr('srcset', altImageUrl);
  };

  const insertImageAltImage = (cardsProduct, productJson) => {
    cardsProduct
      .find('.AspectRatio')
      .append(
        `<img class="ProductItem__Image ProductItem__Image--alternate Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[200,300,400,600,800,900,1000,1200]" data-sizes="auto" alt="${productJson.title}" srcset="${productJson.altImageUrl}">`,
      );
  };

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  });

  // Handle gender filter toggle
  document.addEventListener('click', (event) => {
    const genderToggleItem = event.target.closest(
      '.Linklist__GenderToggle .Linklist__Item',
    );

    if (genderToggleItem) {
      document
        .querySelectorAll('.Linklist__GenderToggle .Linklist__Item')
        .forEach((item) => item.classList.remove('active'));

      genderToggleItem.classList.add('active');
    }
  });
})();
